export enum ListTypes {
  FAVORITES = "FAVORITES",
  FILTERS = "FILTERS",
  FOLDERS = "FOLDERS",
}
